module.exports = __webpack_public_path__ + "img/product-6.65dcfcc9.png";